import React from "react";
import { MoreHorizontal, Eye, Pencil, Trash } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface TableActionItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  className?: string;
  show?: boolean;
}

interface TableActionsProps {
  onView?: () => void;
  viewLabel?: string;
  onEdit?: () => void;
  editLabel?: string;
  onDelete?: () => void;
  deleteLabel?: string;
  actions?: TableActionItem[];
}

const TableActions: React.FC<TableActionsProps> = ({
  onView,
  viewLabel = "View Details",
  onEdit,
  editLabel = "Edit",
  onDelete,
  deleteLabel = "Delete",
  actions = [],
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0 hover:bg-slate-100 dark:hover:bg-slate-800">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl shadow-lg border-slate-100">
        {onView && (
          <DropdownMenuItem
            onClick={onView}
          >
            <Eye className="h-4 w-4" />
            <span>{viewLabel}</span>
          </DropdownMenuItem>
        )}
        {onEdit && (
          <DropdownMenuItem
            onClick={onEdit}
          >
            <Pencil className="h-4 w-4" />
            <span>{editLabel}</span>
          </DropdownMenuItem>
        )}
        {onDelete && (
          <DropdownMenuItem
            onClick={onDelete}
            className="text-red-500 hover:bg-red-50"
          >
            <Trash className="h-4 w-4" />
            <span>{deleteLabel}</span>
          </DropdownMenuItem>
        )}
        {actions
          ?.filter((action) => action.show !== false)
          ?.map((action, idx) => (
            <DropdownMenuItem
              key={idx}
              onClick={action.onClick}
              className={`cursor-pointer  ${action.className || ""}`}
            >
              {action.icon}
              <span>{action.label}</span>
            </DropdownMenuItem>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TableActions;
